import { render, staticRenderFns } from "./FactureNew.vue?vue&type=template&id=16bfe424&"
import script from "./FactureNew.vue?vue&type=script&lang=js&"
export * from "./FactureNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16bfe424')) {
      api.createRecord('16bfe424', component.options)
    } else {
      api.reload('16bfe424', component.options)
    }
    module.hot.accept("./FactureNew.vue?vue&type=template&id=16bfe424&", function () {
      api.rerender('16bfe424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/factures/FactureNew.vue"
export default component.exports